import React from 'react';
import { Box, CardMedia, Container, Stack, Typography } from '@mui/material';
import { useDevice } from '../../hooks/useResponsive';
import GradientCTAButton from './InspectionButton';

const InspectionDirection = () => {
  const { isMobile } = useDevice();

  return (
    <>
      <Container sx={{ pt: 6, pb: 5, px: isMobile ? 2 : 0.8, backgroundColor: 'white' }}>
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/certified.webp"
          alt="Card Image"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px' }}
        />
        <Stack pt={2} pb={3} pr={7} px={1.5}>
          <Typography color="#000000" fontSize={24} fontWeight={800} mb={1} lineHeight={1.2}>
            FOCUS Certified Inspection <br />
            —Trust, Assurance & <br />
            Peace of Mind
          </Typography>
          <Typography fontSize="11px" color="#000000" fontWeight="400" pr={5}>
            FOCUS Motors performs 130+ quality checks on-site, providing a detailed report and warranty-backed assurance
            for confident buying.
          </Typography>
          <Box mt={2}>
            <Typography color="#000000" fontSize="11px">
              📍 Inspection directly at the car’s location
            </Typography>
            <Typography color="#000000" fontSize="11px">
              📑 Comprehensive condition report provided
            </Typography>
            <Typography color="#000000" fontSize="11px">
              🔒 Warranty-backed assurance from FOCUS Motors
            </Typography>
          </Box>
        </Stack>

        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/stepsMobile.webp"
          alt="Card Image"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px', marginBottom: 3 }}
        />
        <GradientCTAButton text="Inspect the Car Now!" />
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/carTech.webp"
          alt="Card Image"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px', mt: 15, mb: 1 }}
        />
        <Stack pt={1} pr={5} px={1.5}>
          <Typography color="#000000" fontSize={24} fontWeight={800} mb={1} lineHeight={1.2}>
            Inspected by Experts.
            <br /> Backed by Warranty!{' '}
          </Typography>
          <Typography fontSize="11px" color="#000000" fontWeight="400" mr={1}>
            The FOCUS Inspection Warranty covers unexpected engine or major component issues if they arise after our
            certified inspection clears them.
          </Typography>
        </Stack>
      </Container>

      <Stack direction="row" sx={{ backgroundColor: 'white' }}>
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/warrenty.webp"
          alt="Card Image"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain' }}
        />
      </Stack>
    </>
  );
};
export default InspectionDirection;
